import React, { useEffect } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import './index.css';

function ObjectiveComponent({
  objective = '',
  updateObjective = () => {},
  clearField = () => {},
  isDisabled = false,
}) {

  function handleOnchange (e) {
    e.preventDefault();
    updateObjective(e);
  }

  function handleClear (name) {
    clearField(name);
  }
  
  useEffect(() => {
    return () => {}
  }, []);

  return (
    <div className="card custom-card">
      <h5 className="card-header ">OBJECTIVE</h5>
      <div className="card-body" style={{ padding: '10px' }}>
        <div className="custom-form-group-container txt-clr" style={{ margin: '5px' }}>
          <TextareaAutosize 
            id="objective" 
            name="objective" 
            type="text" 
            className="form-control custom-textarea" 
            placeholder="Objective" 
            onChange={e => handleOnchange(e)}
            value={objective}
            disabled={isDisabled}
            minRows={2} />
          {!isDisabled && (
            <i 
              className="fal fa-times clear-textarea text-danger"
              onClick={() => handleClear('objective')} 
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ObjectiveComponent;
